<template>
	<div>
		<h1 class="mt-0 mb-5">Orders</h1>

		<order-list />

		<ux-btn color="outline-primary" to="/profile">Back to Profile</ux-btn>
	</div>
</template>

<script>
import OrderList from './OrderList.vue';

export default {
	components: { OrderList },
}
</script>